import React from 'react'
export default function IconWheel() {
  return (
    <svg
      id="wheel"
      xmlns="http://www.w3.org/2000/svg"
      height="22"
      viewBox="0 0 32.378 32.378"
    >
      <g id="Group_21" data-name="Group 21">
        <g id="Group_20" data-name="Group 20">
          <path
            id="Path_43"
            data-name="Path 43"
            d="M96.126,85.333a10.793,10.793,0,1,0,10.793,10.793A10.8,10.8,0,0,0,96.126,85.333Zm5.521,4.031a.675.675,0,0,1,.964-.038A9.393,9.393,0,0,1,105.36,94.2a.675.675,0,0,1-.35.74,4.858,4.858,0,0,1-2.195.507,3.512,3.512,0,0,1-2.444-.818C99.227,93.489,99.7,91.52,101.647,89.364ZM90.6,102.992a.674.674,0,0,1-.474.223H90.1a.674.674,0,0,1-.464-.184,9.392,9.392,0,0,1-2.748-4.877.675.675,0,0,1,.35-.74c1.52-.785,3.689-.638,4.639.312C93.023,98.868,92.546,100.837,90.6,102.992Zm1.277-8.361a3.512,3.512,0,0,1-2.444.818,4.863,4.863,0,0,1-2.195-.507.675.675,0,0,1-.35-.74,9.393,9.393,0,0,1,2.748-4.877.65.65,0,0,1,.49-.184.673.673,0,0,1,.474.222C92.547,91.52,93.024,93.489,91.881,94.632ZM99,105.121a9.435,9.435,0,0,1-5.749,0,.676.676,0,0,1-.469-.69c.169-2.427,1.606-4.258,3.344-4.258S99.3,102,99.469,104.431A.676.676,0,0,1,99,105.121Zm-5.573-8.995a2.7,2.7,0,1,1,2.7,2.7A2.7,2.7,0,0,1,93.427,96.126Zm6.042-8.252c-.169,2.427-1.606,4.257-3.344,4.257s-3.175-1.831-3.344-4.257a.674.674,0,0,1,.468-.689,9.463,9.463,0,0,1,5.752,0A.674.674,0,0,1,99.469,87.874Zm5.89,10.173a9.392,9.392,0,0,1-2.748,4.877.674.674,0,0,1-.464.184h-.026a.673.673,0,0,1-.474-.222c-1.943-2.155-2.42-4.125-1.277-5.268.95-.951,3.117-1.095,4.639-.312A.675.675,0,0,1,105.36,98.046Z"
            transform="translate(-79.937 -79.937)"
            fill="#494949"
          />
          <path
            id="Path_44"
            data-name="Path 44"
            d="M16.189,0A16.189,16.189,0,1,0,32.378,16.189,16.207,16.207,0,0,0,16.189,0Zm0,28.33A12.142,12.142,0,1,1,28.33,16.189,12.155,12.155,0,0,1,16.189,28.33Z"
            fill="#494949"
          />
        </g>
      </g>
    </svg>
  )
}